import React, { useState } from 'react';
import { Button, Modal } from 'react-bootstrap';
import CallCenterNote from './CallCenterNote';
import { FaStickyNote } from 'react-icons/fa';

const CallCenterNotesModal = ({ callId, callData = {} }) => {
    const [show, setShow] = useState(false);
    const [notesCount, setNotesCount] = useState(0);

    const handleOpen = () => {
        setShow(true);
    };

    const handleClose = () => {
        setShow(false);
    };

    const handleNotesChange = (notes) => {
        setNotesCount(notes?.length || 0);
    };

    return (
        <>
            <Button variant="outline-secondary" onClick={handleOpen} disabled={!callId} title={'View Call Notes'}>
                <FaStickyNote />
                <span className="ml-2">Notes {`(${notesCount || callData?.callNotesCount || 0})`}</span>
            </Button>
            <Modal show={show} onHide={handleClose} size="md" centered>
                <Modal.Body>
                    <CallCenterNote callId={callId} onNotesChange={handleNotesChange} />
                </Modal.Body>
            </Modal>
        </>
    );
};

export default CallCenterNotesModal;
